import React from "react";
import {Helmet} from "react-helmet";

const SITE_URL = "https://bekymringsmestring.no";
const DEFAULT_IMAGE = "https://bekymringsmestring.no/meditation.jpg";
const DEFAULT_DESCRIPTION =
    "Forskningsbasert og helhetlig kurs i bekymringsmestring. Bygget på metakognitiv terapi, mindfulness og emosjonsfokuserte prinsipper. Finn autoriserte kursholdere over hele landet.";

export const SeoHead = ({
    title,
    description = DEFAULT_DESCRIPTION,
    path = "/",
    image = DEFAULT_IMAGE,
    type = "website",
}) => {
    const formattedTitle = title
        ? title.includes("Bekymringsmestring")
            ? title
            : `${title} | Bekymringsmestring`
        : "Kurs i Bekymringsmestring | Forskningsbasert mestring og meditasjon";

    const canonicalUrl = `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
    const imageToUse = image || DEFAULT_IMAGE;
    const fullImageUrl =
        typeof imageToUse === "string" && imageToUse.startsWith("http")
            ? imageToUse
            : `${SITE_URL}${typeof imageToUse === "string" && imageToUse.startsWith("/") ? imageToUse : `/${imageToUse}`}`;

    return (
        <Helmet>
            <title>{formattedTitle}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={canonicalUrl} />

            {/* Open Graph / Facebook */}
            <meta property="og:site_name" content="Bekymringsmestring" />
            <meta property="og:type" content={type} />
            <meta property="og:title" content={formattedTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={canonicalUrl} />
            <meta property="og:image" content={fullImageUrl} />
            <meta property="og:locale" content="nb_NO" />

            {/* Twitter Card */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={formattedTitle} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={fullImageUrl} />
        </Helmet>
    );
};
